import React from 'react';

const Picker = (props) => {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="#010A21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6797 1.40625H14.0625V0.5625C14.0625 0.251859 13.8107 0 13.5 0C13.1893 0 12.9375 0.251859 12.9375 0.5625V1.40625H5.0625V0.5625C5.0625 0.251859 4.81068 0 4.5 0C4.18932 0 3.9375 0.251859 3.9375 0.5625V1.40625H2.32031C1.04087 1.40625 0 2.44712 0 3.72656V15.6797C0 16.9591 1.04087 18 2.32031 18H15.6797C16.9591 18 18 16.9591 18 15.6797V3.72656C18 2.44712 16.9591 1.40625 15.6797 1.40625ZM2.32031 2.53125H3.9375V3.09375C3.9375 3.40439 4.18932 3.65625 4.5 3.65625C4.81068 3.65625 5.0625 3.40439 5.0625 3.09375V2.53125H12.9375V3.09375C12.9375 3.40439 13.1893 3.65625 13.5 3.65625C13.8107 3.65625 14.0625 3.40439 14.0625 3.09375V2.53125H15.6797C16.3388 2.53125 16.875 3.06745 16.875 3.72656V5.0625H1.125V3.72656C1.125 3.06745 1.6612 2.53125 2.32031 2.53125ZM15.6797 16.875H2.32031C1.6612 16.875 1.125 16.3388 1.125 15.6797V6.1875H16.875V15.6797C16.875 16.3388 16.3388 16.875 15.6797 16.875Z"/>
    </svg>

  );
};

export default Picker;
